import { Chip as MUIChip } from "@material-ui/core";
import { ChipProps } from "@material-ui/core/Chip";
import {
    createStyles,
    WithStyles,
    withStyles,
    WithTheme,
} from "@material-ui/core/styles";
import classnames from "classnames";
import * as React from "react";

import { RelodeTheme } from "../";

const styles = (theme: RelodeTheme) =>
    createStyles({
        root: {
            fontSize: "16px",
            lineHeight: "24px",
            marginBottom: theme.spacing(1),
            marginRight: theme.spacing(1),
        },
        selected: {
            backgroundColor: theme.relode.colors.chip.selected.light,
            color: theme.relode.colors.chip.selected.contrastText,
            "&:focus": {
                backgroundColor: theme.relode.colors.chip.selected.light,
            },
            "&:hover": {
                backgroundColor: theme.relode.colors.chip.selected.main,
            },
        },
        unselected: {
            backgroundColor: theme.relode.colors.chip.unselected.light,
            color: theme.relode.colors.chip.unselected.contrastText,
            "&:focus": {
                backgroundColor: theme.relode.colors.chip.unselected.light,
            },
            "&:hover": {
                backgroundColor: theme.relode.colors.chip.unselected.main,
            },
        },
        enabled: {},
        disabled: {},
        cannotEdit: {
            cursor: "not-allowed",
        },
        deleteIcon: {
            marginRight: theme.spacing(1),
        },
    });

type Props = WithStyles<typeof styles> &
    WithTheme & {
        label: React.ReactNode;
        className?: string;
        style?: React.CSSProperties;
        id?: number | string;
        value?: string | number | object | boolean;
        selected?: boolean;
        enabled?: boolean;
        color?: "default" | "primary" | "secondary";
        variant?: "default" | "outlined";
        tabIndex?: number;
        icon?: React.ReactElement<any>;
        dataCy?: string;
        onChipClick?: (id?: number | string, value?: any) => void;
        onChipDelete?: (id?: number | string, value?: any) => void;
    };

const getProps = (incoming: Props) => {
    const {
        classes,
        color = "primary",
        className: classNameProp,
        label,
        onChipClick,
        onChipDelete,
        icon,
        id,
        selected = true,
        enabled = true,
        variant = "default",
        tabIndex,
        value,
        style,
        dataCy,
    } = incoming;

    const props: ChipProps = {};

    props.icon = icon;
    props.id = id ? id.toString() : undefined;
    props.color = color;
    props.variant = variant;
    props.tabIndex = tabIndex;
    props.onDelete = onChipDelete ? () => onChipDelete(id, value) : undefined;
    props.onClick = onChipClick ? () => onChipClick(id, value) : undefined;
    props.label = label;
    props.style = style;

    props.classes = {
        deleteIcon: classes.deleteIcon,
    };

    props.className = classnames(
        classes.root,
        {
            [classes.selected]: selected,
            [classes.unselected]: !selected,
            [classes.enabled]: enabled,
            [classes.disabled]: !enabled,
            [classes.cannotEdit]: !onChipClick && !onChipDelete,
        },
        classNameProp
    );

    return props;
};

export const Chip = withStyles(styles, { name: "Chip", withTheme: true })(
    (props: Props) => <MUIChip {...getProps(props)} data-cy={props.dataCy} />
);
